export default __webpack_public_path__ + "static/media/ai_copy_icon.d7903fed.svg";